export default {
  URL: process.env.REACT_APP_URL,
  ENV: process.env.NODE_ENV,
  GOOGLE_MAPS_API_KEY: process.env.REACT_APP_GOOGLE_API,
  MERCADOPAGO_PUBLIC_KEY: process.env.REACT_APP_MERCADOPAGO_PUBLIC_KEY,
  PLAY_STORE_LINK: process.env.REACT_APP_PLAY_STORE_LINK,
  APP_STORE_LINK: process.env.REACT_APP_APP_STORE_LINK,
  FACEBOOK_LINK: process.env.REACT_APP_FACEBOOK_LINK,
  INSTAGRAM_LINK: process.env.REACT_APP_INSTAGRAM_LINK,
  LINKEDIN_LINK: process.env.REACT_APP_LINKEDIN_LINK,
  LIVECHAT_KEY: process.env.REACT_APP_LIVECHAT_KEY,
  LANDING_URL: process.env.REACT_APP_LANDING_URL || 'https://space.guru',
}



// WEBPACK FOOTER //
// ./src/config.js